import React from 'react';

const IconOk = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M8.226 16.992l-4.225-4.187l1.31-1.297l2.915 2.888l8.473-8.394L18.008 7.3L8.226 16.992z" />
</svg>);

export default IconOk;
